import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import CEProductCustomizationPdp from './CEProductCustomizationPdp.jsx';

const parseJSONAttribute = (value) => {
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch (error) {
    console.error('Failed to parse JSON attribute:', error);
    return null;
  }
};

const mountProductCustomizationPdp = () => {
  const element = document.getElementById('product-customization-pdp-react');

  if (!element) {
    console.warn('Product customization drawer root element not found');
    return;
  }

  if (element.dataset.reactMounted === 'true') {
    return;
  }
  element.dataset.reactMounted = 'true';

  const product = parseJSONAttribute(element.getAttribute('data-product'));

  const storeName = element.getAttribute('data-store-name') || 'product-customization-pdp';
  const watchStoreChangesAttr = element.getAttribute('data-watch-store-changes');
  const watchStoreChanges = watchStoreChangesAttr !== 'false';

  const language = element.getAttribute('data-language');
  const locale = element.getAttribute('data-locale');
  const currencyCode = element.getAttribute('data-currency-code');
  const country = element.getAttribute('data-country');
  const market = element.getAttribute('data-market');

  const productHandle = element.getAttribute('data-product-handle') || product?.handle || null;
  const productType = element.getAttribute('data-product-type') || undefined;
  const playerHandle = element.getAttribute('data-player-handle') || undefined;
  const competitionHandle = element.getAttribute('data-competition-handle') || undefined;

  const showProductImageAttr = element.getAttribute('data-show-product-image');
  const showProductImage = showProductImageAttr !== 'false';

  const isAlwaysVisibleAttr = element.getAttribute('data-is-always-visible');
  const isAlwaysVisible = isAlwaysVisibleAttr !== 'false';
  const isShopByPlayer = element.getAttribute('data-is-shop-by-player') === 'true';
  const isPreorder = element.getAttribute('data-is-preorder') === 'true';
  const preorderLabel = element.getAttribute('data-preorder-label') || undefined;
  const attentionMessage = element.getAttribute('data-attention-message') || undefined;

  const localization =
    locale || country || market
      ? {
          locale: locale ?? undefined,
          country: country ?? undefined,
          market: market ?? undefined,
        }
      : undefined;

  createRoot(element).render(
    <StrictMode>
      <CEProductCustomizationPdp
        product={product}
        storeName={storeName}
        watchStoreChanges={watchStoreChanges}
        language={language}
        locale={locale}
        currencyCode={currencyCode}
        country={country}
        market={market}
        localization={localization}
        productHandle={productHandle}
        productType={productType}
        playerHandle={playerHandle}
        competitionHandle={competitionHandle}
        showProductImage={showProductImage}
        isAlwaysVisible={isAlwaysVisible}
        isShopByPlayer={isShopByPlayer}
        isPreorder={isPreorder}
        preorderLabel={preorderLabel}
        attentionMessage={attentionMessage}
      />
    </StrictMode>,
  );
};

mountProductCustomizationPdp();
